import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { valueMaxDistanceSliderMap } from '../../../utils/value-max-distance-slider-map';
import { RegisterUserFormService } from '../../../services/register-user-form.service';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormField } from '../../form/abstracts';

@Component({
  selector: 'app-max-distance-field',
  standalone: true,
  imports: [TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: MaxDistanceFieldComponent
    },
  ],
  templateUrl: './max-distance-field.component.html',
  styleUrls: ['./max-distance-field.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MaxDistanceFieldComponent extends BaseFormField<number> {
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string> = input.required<string>();
  
  private _registerUserFormService = inject(RegisterUserFormService);

  private readonly _maxDistanceWalking = computed(() => {
    return this._registerUserFormService.maxDistanceWalking();
  });
  
  public sliderValue: number;

  public maxDistanceWalkingLabels: { value: number, label: string }[] = [
    { label: '200m', value: 200 },
    { label: '500m', value: 500 },
    { label: '1km', value: 1000 },
    { label: '2km', value: 2000 },
    { label: '3km', value: 3000 },
  ];
  
  updateSlideOnLabelChange = effect(() => {
    this.sliderValue = this._mapValueToSliderValue(this._maxDistanceWalking());
  }, { allowSignalWrites: true });

  public handleSliderMaxDistanceChange(event: Event) {
    const slider = event.target as HTMLInputElement;
    const value = Number(slider.value);
    const maxDistance = valueMaxDistanceSliderMap(value);
    this._registerUserFormService.setMaxDistanceWalking(maxDistance);
    this.form().get(this.formControlName())?.setValue(maxDistance);
  }
  
  public handleMaxDistanceWalkingLabelClick(value: number) {
    this._registerUserFormService.setMaxDistanceWalking(value);
    this.form().get(this.formControlName())?.setValue(value);
  }
  
  private _mapValueToSliderValue(value: number): number {
    switch (value) {
      case 200:
        return 10;
      case 500:
        return 20;
      case 1000:
        return 30;
      case 2000:
        return 40;
      case 3000:
        return 50;
      default:
        return 0;
    }
  } 
}
